export class AddNewGrower {
  ABNumber: number;
  FirstName: string;
  LastName: string;
  BusinessName: string;
  GrowerCode: string;
  GLN: string;
}

export class Address {
  Address1: string;
  Address2: string;
  State: string;
  City: string;
  Zip: string;
}

export class GrowerSearchFilter {
  ABNumber: number;
  FirstName: string;
  LastName: string;
  BusinessName: string;
  Email: string;
  GLN: string;
  City: string;
  State: string;
  GrowerCode: string;
}

export class SellerSearchFilter {
  ABNumber: number;
  FirstName: string;
  LastName: string;
  Email: string;
  City: string;
  State: string;
  SellerCode: string;
}

export class dashboradDDL {
  accounts: any[];
  states: any[];
}

export class GrowerError {
  ABNumber: boolean;
  FirstName: boolean;
  LastName: boolean;
  BusinessName: boolean;
  Email: boolean;
  City: boolean;
  State: boolean;
  Zip: boolean;
  Address1: boolean;
  GrowerCode: boolean;
  GLN: boolean;
}

export class SellerError {
  ABNumber: boolean;
  FirstName: boolean;
  LastName: boolean;
  Email: boolean;
  City: boolean;
  State: boolean;
  Zip: boolean;
  Address1: boolean;
  PhoneNo: boolean;
}

export class apiResponse {
  status: boolean;
  message: string;
  resultData: any[];
}

export class AccountSearchFilter {
  BusinessName: string;
  City: string;
  State: string;
  AccountNo: string;
}
export class AccountError {
  BusinessName: boolean;
  City: boolean;
  State: boolean;
  AccountNo: boolean;
}

export class AddNewSeller {
  ABNumber: number;
  FirstName: string;
  LastName: string;
  SellerCode: string;
  Address1: string;
  Address2: string;
  State: string;
  City: string;
  Zip: string;
  Email: string;
  PhoneNo: string;
}
